/**
 * Costa Rican colón.
 */
export var CRC = {
  code: 'CRC',
  base: 10,
  exponent: 2
};